import React from "react";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import PaymentMethodsIcon from "../../assets/icons/payment_methods.svg2";
import WhiteButton from "../Common/WhiteButton";
import Subheading from "../Common/Subheading";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import NewFeature from "../Builder/Components/NewFeature";
import HelpButton from "../HelpContent/HelpButton";

export default function BillingPaymentMethods() {
  return (
    <div>
      <NewFeature>
        <div className="d-flex justify-content-between align-items-center">
          <Subheading
            Icon={PaymentMethodsIcon}
            heading="Billing Payment Methods"
            subheading="Manage the cards or payment methods linked to your account"
          />
          <div>
            <WhiteButton
              as="RRLink"
              icon={ContactsIcon}
              heading="Boomerang UI Sales"
            />
          </div>
        </div>
        <hr className="my-3 text-secondary" />
        <div className="d-flex justify-content-start">
          <button
            type="submit"
            className="btn btn-colored-reverse rounded-pill fw-bold "
          >
            <FontAwesomeIcon icon={faPlusCircle} className="me-2" />
            New Card
          </button>
        </div>
      </NewFeature>
    </div>
  );
}
